import { menuItems } from '@/components/app/layout/AppLayout/data';
import { HeaderProps } from '@/components/app/layout/Header/types';
import MobileHeader from '@/components/app/layout/MobileHeader';

const CalmMobileHeader = ({ isNavOpen, setIsNavOpen }: HeaderProps) => (
	<MobileHeader isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen} menuItems={menuItems} />
);

export default CalmMobileHeader;
